import { put } from "redux-saga/effects";
import axiosGovernorate from "../../axios-governorate";
import * as actions from "../actions";
import { POST_CONTEXT } from "../../lib/enums";

export function* getChatPostsSaga({ chatType }: any) {
  try {
    const response = yield axiosGovernorate.get(`/api/chat/posts/${chatType}`);

    const { chatPosts, newPosts } = JSON.parse(response.data).data;
    yield put(actions.updateState({ chatPosts, newPosts }));
  } catch (error) {
    console.log(error.message);
  }
}

export function* sendPostSaga({ chatType, content }: any) {
  try {
    const response = yield axiosGovernorate.post("/api/postAction", {
      action: "sendPost",
      context: POST_CONTEXT.Chat,
      chatId: chatType,
      content
    });

    const { chatPosts } = JSON.parse(response.data).data;
    yield put(actions.updateState({ chatPosts }));
  } catch (error) {
    console.log(error.message);
  }
}

export function* deletePostsSaga({ postIds }: any) {
  try {
    const response = yield axiosGovernorate.post("/api/postAction", {
      action: "deletePosts",
      context: POST_CONTEXT.Chat,
      postIds
    });

    const { chatPosts } = JSON.parse(response.data).data;
    yield put(actions.updateState({ chatPosts }));

    yield put(actions.closeDialog());
  } catch (error) {
    console.log(error.message);
    yield put(actions.closeDialog());
  }
}
